// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f30c69b5","453":"9f7e2606","455":"bfe21f51","977":"bd77859d"}[chunkId] + ".chunk.js";
};